<template>
  <section class="container w-full mx-auto pb-24 px-4 md:px-2">
    <section class="container mx-auto pb-24 px-4 md:px-2">
      <h1 class="font-bold text-xl md:text-3xl text-left md:text-center mb-12">
        Perguntas frequentes
      </h1>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            Como a Easytermos me auxilia na adequação à LGPD?
          </p>
          <p class="text-gray-700">
            A Easytermos gera diversos documentos obrigatórios ou considerados
            boas práticas de mercado para a adequação de sua empresa à LGPD como
            Política de Privacidade, Termos de Uso, Política de Cookies, entre
            outros.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            Quem precisa se adequar à LGPD?
          </p>
          <p class="text-gray-700">
            Qualquer pessoa, física ou jurídica (pública ou privada) que realize
            tratamento de dados pessoais. Portanto, a LGPD não se destina apenas
            a quem trata dados coletados na internet, mas a qualquer operação de
            tratamento de dados pessoais que tenham sido coletados dentro do
            território brasileiro ou que tenha como objetivo oferecer bens ou
            serviços a pessoas localizadas no Brasil, independentemente destes
            dados pessoais terem sido coletados offline ou online, em meios
            físicos ou digitais.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            O que é tratamento de dados pessoais?
          </p>
          <p class="text-gray-700">
            Tratamento é qualquer tipo de manipulação realizada com dados
            pessoais, seja fisicamente ou virtualmente - como visualizar dados,
            compartilhá-los, coletá-los, arquivá-los, entre outros.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            O que a LGPD considera como dados pessoais?
          </p>
          <p class="text-gray-700">
            Para a LGPD, dado pessoal é qualquer tipo de dado, seja em meio
            digital ou físico, que possa individualizar ou levar a identificação
            de alguém. Dado pessoal pode ser nome, dados financeiros,
            escolaridade, entre outros que, separados ou juntos, individualizam
            uma pessoa. Ainda, a LGPD conta com o conceito de dados pessoais
            sensíveis, que são toda informação que revele a raça, origem étnica,
            religião, preferência política/partidária, filiação sindical,
            condição de saúde, orientação sexual, biometria ou características
            genéticas de alguém.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            Você pode explicar cookies de terceiros? O que eles são? Por que
            eles apresentam um problema de privacidade?
          </p>
          <p class="text-gray-700">
            Cookies (também chamados de cookie HTTP, cookie da web, cookie do
            navegador) são dados enviados de um site e armazenados em seu
            navegador durante a navegação nesse site. Eles foram projetados para
            ajudar os sites a lembrar ou descobrir certas informações sobre o
            usuário visitante. Basicamente, permitem que proprietários de sites
            e terceiros rastreiem a atividade do usuário na web. Essa também é a
            raiz das principais preocupações com a privacidade. Os chamados
            cookies de rastreamento, ou especialmente seu subconjunto, cookies
            de rastreamento de terceiros são usados para compilar registros de
            longo prazo de históricos de navegação de indivíduos. <br />
            Esses cookies permitem um perfil bastante completo do usuário
            rastreando o comportamento em vários sites. Um exemplo é o Google
            AdSense e Analytics, que podem servir publicidade e pesquisas
            personalizadas. A legislação da maioria dos países exige que os
            cookies sejam mencionados em uma política de privacidade.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            Se eu tiver um aplicativo móvel, qual é uma boa prática para uma
            política de privacidade?
          </p>
          <p class="text-gray-700">
            Em geral, é considerado uma boa prática criar um link para sua
            política de privacidade no aplicativo e na "página de download" da
            app store. A razão para isso é que os usuários devem ser capazes de
            ver as práticas de coleta de dados antes que elas realmente
            aconteçam.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            Meus newsletters por e-mail (usando serviços como MailChimp) devem
            conter uma política de privacidade?
          </p>
          <p class="text-gray-700">
            Sim. Newsletters por email devem conter uma referência à sua
            política de privacidade. Não se esqueça que outra parte importante é
            mostrar um link para sua política de privacidade quando o usuário se
            inscrever na mesma, a fim de informar o usuário sobre suas práticas
            de coleta / uso de dados. Além da referência à política de
            privacidade, há uma coisa que você não deve esquecer: você precisa
            seguir a legislação CAN-SPAM. Que exige que você forneça itens como
            um link de cancelamento.
          </p>
        </div>
      </div>
      <div class="flex items-start justify-start mb-12">
        <div>
          <p class="font-semibold mt-0 mb-3 text-gray-900">
            Preciso de uma política de privacidade para uma página do Facebook
            simples ou para minha organização sem fins lucrativos?
          </p>
          <p class="text-gray-700">
            Não, uma simples página do Facebook não requer uma política de
            privacidade para uma organização sem fins lucrativos. No entanto, se
            você começou a coletar informações sobre seus usuários, o Facebook
            exige que você divulgue. <br />
          </p>
        </div>
      </div>
    </section>

    <div class="text-center">
      <a
        href="/app"
        target="_blank"
        class="btn bg-et-500 text-white btn-lg btn-icon"
      >
        <span>Começar agora sem custos</span>
        <svg viewBox="0 0 20 20" fill="currentColor" class="ml-3">
          <path
            fill-rule="evenodd"
            d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </a>
    </div>
  </section>
</template>

<script>
import Btn from '@/components/Home/HomeET/Btn';
export default {
  name: 'FAQ',
  components: { Btn },
  data: () => ({
    open: false,
    page: {
      page:
        '####  O que é a LGPD? E por que sua empresa deve se adequar?\n\n\nA LGPD traz segurança e modernidade para a internet; veja o que vai mudar e o que você deve fazer para se\nadequar.\n\nAprovada em 2018, a LGPD (Lei Geral de Proteção de Dados) entrou em vigor em agosto de\n2020, trazendo grandes mudanças para a atuação virtual de todas as empresas e cidadãos do\nBrasil, especialmente na área jurídica, de segurança e administrativa. Com o propósito de\ngarantir a liberdade e a privacidade dos consumidores e usuários, essa lei estabelece medidas\nde segurança e determina uma série de direitos e obrigações para que os dados pessoais sejam\ntratados com mais cuidado, e o cidadão fique mais protegido no meio virtual. Portanto, a\nrelação das empresas com o público vai mudar, mas não se preocupe, se adequar a esses\nnovos padrões é mais fácil do que parece e você pode ver a seguir o que está mudando para\nnós e porquê.\n\n#### 1. O que é a LGPD?\n\nA lei no 13.709 se fundamenta em diversos valores, como o respeito à privacidade e à\nliberdade de expressão. Dentro de seu texto, ela define o que são “dados pessoais”, com suas\ndiversas variações, e como as empresas, tanto públicas quanto privadas, devem lidar com\nesses dados, fazendo uma coleta e um uso justos dos mesmos. Um conceito chave para\nentender a lei é o consentimento, que vai além de pedir permissão para os usuários para o uso\nde suas informações. Com a LGPD, as companhias devem explicar o porquê da coleta de\ninformações e como esses dados serão armazenados e usados, fazendo isso de forma clara e\nexplícita. O objetivo, claro, é evitar que sites mal intencionados se aproveitem das\ninformações pessoais de seus usuários (como RG e CPF, por exemplo), que muitas vezes os\ncompartilham sem saber de todos os detalhes deste processo.\n\n#### - De onde ela surgiu?\n\nA LGPD brasileira foi criada aos moldes da GDPR (Regulamento Geral de Proteção de\nDados da União Europeia, em português), também criada em 2018 e com um objetivo\nparecido, cuidar da segurança de informação dos cidadãos da União Europeia. As duas foram\nprojetadas após um escândalo de privacidade de dados envolvendo o Facebook, o que\nlevantou suspeitas sobre o uso geral de dados pessoais por outras grandes companhias, como\no Google e a Apple. A criação dessa lei é um grande passo para o Brasil, pois aqui tínhamos\nsomente algumas notas gerais em códigos legislativos, como o Código de Defesa do\n\nConsumidor e o Marco Civil da Internet, para tratar deste tipo de problema. Agora, temos um\nconjunto de leis específico para tratar do controle de informações, o que é algo muito positivo\npara o consumidor.\n\n#### 2. Por que você precisa se adequar?\n\nPrimeiramente, é bom ressaltar que a LGPD estará vigente em todo o território nacional,\nmesmo se a sede ou o banco de dados de uma empresa esteja em outro país. Da mesma\nforma, a nacionalidade do usuário não importa. Dessa forma, as empresas que atuam\nvirtualmente em território brasileiro precisam atender a certos padrões exigidos por essa lei.\nAssim, todo o processo de tratamento de informações deve ser explicitado para o usuário\ncomum, que terá controle sobre o uso de seus dados pessoais, podendo requerer a exclusão de\nsuas informações e cancelar seu consentimento, além de poder procurar punir os responsáveis\npor algum dano causado pela má utilização dessas informações. Essa adaptação vai acarretar\nem mudanças práticas na vida empresarial, e pode ser chata, mas ela garante direitos\nfundamentais para todos os usuários e, por tornar as coisas mais claras, vai resultar em um\nambiente de consumo mais agradável, além de extinguir disputas legais que se perdem em\numa legislação confusa.\n\n#### - Há sanções?\n\nSim. A lei contará com a Autoridade Nacional de Proteção de Dados Pessoais (ANPD), órgão\nresponsável pela fiscalização da conduta das empresas e da penalização daqueles que\ndescumprirem a LGPD. Esta instituição federal também terá o papel de orientar a aplicação\nda lei e poderá contar com a ajuda de civis e organizações. Serão definidas algumas medidas\npreventivas de segurança e planos de contingência, aos quais as empresas terão de atender.\nNo caso de vazamento de dados, por exemplo, a ANPD deve ser comunicada imediatamente,\nassim como os titulares prejudicados. A Autoridade aplicará penalidades que variam de\nacordo com a gravidade das falhas, porém, também enviará alertas e orientações antes da\naplicação de qualquer sanção, que podem vir pela forma de multas ou bloqueios. A LGPD\ntambém contará com os agentes de tratamento de dados, divididos nas seguintes categorias: o\n“agente controlador”, quem toma as decisões sobre o processo de tratamento; o “agente\noperador”, que efetua o tratamento a partir das decisões do controlador; e “agente\nencarregado”, que trata da é a interação com o público e a autoridade nacional.\n\n#### - Como se adequar?\n\nA LGPD representa uma modernização importante para o cenário virtual brasileiro, tanto\npara a segurança do consumidor, quanto para o ambiente empresarial. Porém, por ser algo\nmuito novo, muitas empresas ainda não estão preparadas para essas mudanças e o processo\nde adaptação pode parecer confuso. A lei exige a contratação de profissionais para cuidar\nexclusivamente da proteção de dados, tanto dos usuários quanto dos funcionários da empresa,\nque terão a função de prestar contas à ANPD. Da mesma forma, é recomendável a\ncontratação de especialistas na área de segurança digital, além de investimentos no setor.\nFazer um bom catálogo dos dados e documentos armazenados também é essencial, uma vez\nque eles devem estar sempre à disposição dos usuários, em conjunto com um arquivamento\nseguro e sigiloso. A comunicação com o público é uma parte essencial deste novo modelo\nproposto pela LGPD, e a criação de formulários claros e precisos, que explicitem para o\nusuário as informações necessárias, também é um passo fundamental',
    },
  }),
};
</script>

<style scoped></style>
